import { storeToRefs } from 'pinia'
import { useSettingsStore } from '@/stores/settings/settingsStore'

export const formatDateTimeToLocaleString = (date: string) => {
  const parsedDate = new Date(date)

  const { interfaceLanguage } = storeToRefs(useSettingsStore())

  return new Intl.DateTimeFormat(interfaceLanguage.value || undefined, {
    dateStyle: 'short',
    timeStyle: 'medium',
  }).format(parsedDate)
}
